var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 180,
    viewBox: "0 0 181 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13963_72011)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13963_72011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.48828 136.919V160.458C1.48828 163.843 4.25635 166.611 7.64086 166.611C14.2479 166.611 17.1345 161.391 17.1345 161.391L17.5711 58.8419L22.9828 53.2563L167.005 47.3744V44.4463C167.005 39.7124 163.168 35.8754 158.434 35.8754H100.744C98.4715 35.8754 96.2902 34.9725 94.6839 33.3662L77.0145 15.6967C75.4082 14.0904 73.2269 13.1875 70.9548 13.1875H10.0592C5.32525 13.1875 1.48828 17.0245 1.48828 21.7584V35.8774V40.4849V136.919Z",
    fill: "#007AFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_13963_72011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.64062 166.611C11.0251 166.611 13.7932 163.843 13.7932 160.459V55.9361C13.7932 51.208 17.6262 47.375 22.3543 47.375H170.749C175.477 47.375 179.31 51.208 179.31 55.9361V158.052C179.31 162.78 175.477 166.613 170.749 166.613L7.64062 166.611Z",
    fill: "#007AFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98.9306 137.5H83.0694C80.2765 137.5 78.0071 135.631 78.0071 133.332V113.638C76.606 113.784 75.1397 113.414 74.0684 112.529L62.3862 102.914C61.4919 102.178 60.9981 101.199 61 100.156C61 99.1152 61.4937 98.1383 62.3881 97.4037L87.6528 76.6042C89.4396 75.1319 92.5623 75.1319 94.3491 76.6042L119.614 97.4068C120.506 98.1398 121 99.1167 121 100.158C121 101.201 120.508 102.178 119.614 102.915L107.93 112.531C106.857 113.414 105.39 113.785 103.991 113.639V133.333C103.991 135.631 101.722 137.5 98.9306 137.5ZM83.5948 132.899H98.4015V103.69L104.584 108.778L115.055 100.161L90.9991 80.3568L66.9417 100.161L77.4128 108.778L83.5948 103.694V132.899Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13963_72011",
    x: -2.51172,
    y: 13.1875,
    width: 173.516,
    height: 161.422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13963_72011"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13963_72011",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_13963_72011",
    x: 3.64062,
    y: 47.375,
    width: 179.668,
    height: 127.238,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13963_72011"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_13963_72011",
    result: "effect2_dropShadow_13963_72011"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_13963_72011",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13963_72011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/File_Icon.7ed1a7276d87c066e9a618111b99bc9d.svg";
export { ForwardRef as ReactComponent };